import React from 'react';
import { Button } from '@forge/common';
import { useTranslation } from 'react-i18next';

export interface ActivityRetryButtonProps {
  isRetrying: boolean;
  onClick: () => void;
  className?: string;
}

const ActivityRetryButton: React.FC<ActivityRetryButtonProps> = ({
  isRetrying,
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  const handleClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    onClick();
  };

  return (
    <Button
      className={className ?? 'activity-retry-btn'}
      variant="quiet-primary"
      onClick={handleClick}
      disabled={isRetrying}
    >
      {isRetrying ? t('activityLogRetrying') : t('activityLogRetry')}
    </Button>
  );
};

export default ActivityRetryButton;
